export const HorizontalAndVerticalCardConfig: any = {
  url: 'http://localhost:1340',
  thumbImgUrl:
    'https://tfw-v11-assets.s3.us-east-1.amazonaws.com/demo-website/self-storage-units-thumb.JPG',
  ImgUrl:
    'https://tfw-v11-assets.s3.us-east-1.amazonaws.com/demo-website/self-storage-units.JPG',
  currencyCodes: {
    USD: '$',
    EUR: '€',
    GBP: '£',
    INR: '₹',
  },
  categories: {
    '': {
      label: 'Regular',
      icon: 'FaBox',
    },
    'Climate Controlled': {
      label: 'Climate Controlled',
      icon: 'FaThermometerHalf',
    },
    Mobile: {
      label: 'Mobile',
      icon: 'FaTruckMoving',
    },
    'Outdoor Parking': {
      label: 'Outdoor Parking',
      icon: 'FaParking',
    },
  },
  unitTypeArrayLength: 3,
  urls: {
    moveIn: 'move-in',
    reservation: 'reserve',
    bev: 'bev',
  },

  verticalVariantIconSizes: {
    categoryIcon: 24,
    groupIcon: 24,
    amenitiesIcon: 14,
  },
  rateText: 'Rate',
  perMonth: '/mo.',
  horizontalOnlineRate: ' - Online Offer',
  alertTextTwoUnits: 'Hurry! Only 2 Units Left',
  alertTextFewUnits: 'Hurry! Only few Units Left',
  amentityIconSize: 20,
  maxAmenitiesCount: 4,
  totalAmentiesCount: 6,
  alertTextCount: 3,
};
